module.exports = __webpack_public_path__ + "static/media/placeholder.3d0c5526.svg";